export default "__VITE_ASSET__5bb7e0a2__"